import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import _ from "lodash";
import ApikishPortInfo from "../../../core/api/api.kishPortInfo";
import Modal from "react-bootstrap/Modal";
import { isMobile } from "react-device-detect";
import SkeletonKishPortInfo from "../../components/SkeletonComponent/SkeletonKishPortInfo";
import { Zoom } from "react-awesome-reveal";

function KishPortInfo() {
  const [body, setBody] = useState([]);

  const [showMore, setShowMore] = useState(false);
  const [selectedId, setSelectedId] = useState();
  const [showImage, setShowImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    (async () => {
      try {
        let response = await ApikishPortInfo.getAllkishPortInfo({
          pageSize: 100,
          pageNumber: 1,
        });
        if (response.succeeded) {
          setBody(response.data);
          setLoading(false);
        }
      } catch (error) {}
    })();
    return () => {};
  }, []);
  const openImage = (itemFiles) => {
    setShowImage(true);
    setSelectedImage(itemFiles);
  };
  const handleClose = () => {
    setShowImage(false);
  };
  const showText = (id) => {
    setSelectedId(id);
    setShowMore(true);
  };
  const hideText = (id) => {
    setSelectedId(id);
    setShowMore(false);
  };
  return (
    <Container fluid className="">
      <Container>
        <div className="mt-4 pt-3 mt-xl-0 pt-xl-0">
          <div className="mt-4 pt-lg-5 d-flex align-items-center">
            <Col xs={1} lg={4} xl={4} className="px-0">
              {" "}
              <hr />
            </Col>
            <Col>
              {" "}
              <h1 className="text-center fs-normal fw-bold">
                {" "}
                اطلاعات حرکت شناورها از بندر چارک{" "}
              </h1>
            </Col>
            <Col xs={1} lg={4} xl={4} className="px-0">
              <hr />
            </Col>
          </div>
          {loading ? (
            <SkeletonKishPortInfo />
          ) : (
            <Row className="pb-5 mb-5 " style={{ overflowX: "hidden" }}>
              {!_.isEmpty(body) &&
                body?.map((item, key) => (
                  <Col
                    key={key}
                    xs={12}
                    md={4}
                    lg={4}
                    xl={4}
                    className="bg-white my-2 mx-0 border  pb-2 shadow-sm "
                    style={{ borderRadius: "10px" }}
                  >
                    {/* <div className='d-flex justify-content-end mx-3 mb-2 pb-0 pt-2 mt-2 '>
                       
                        <span className='text-muted small' style={{ fontSize: "10px" }}> تاریخ ایجاد:{item.created}</span>
                    </div> */}
                    {item?.files.length > 0 && (
                      <Col xs={12} lg={10} xl={10} className="">
                        {item?.files?.map(
                          (fileItem, key) =>
                            //این شرط حذف شود
                            key == 0 && (
                              <div key={key}>
                                <img
                                  onClick={() => {
                                    openImage(item.files);
                                  }}
                                  src={
                                    process.env.REACT_APP_API_URL +
                                    "/File/" +
                                    fileItem +
                                    `.jpg`
                                  }
                                  className="img-thumbnail w-100 mt-2 py-0 rounded"
                                  style={{
                                    border: "0",
                                    height: "100%",
                                    cursor: "pointer",
                                  }}
                                  alt="no-image"
                                ></img>
                              </div>
                            )
                        )}
                      </Col>
                    )}
                    {item?.message && (
                      <Col>
                        {isMobile && item?.message.length > 150 ? (
                          <>
                            <p className="mt-2">
                              {showMore && selectedId == item.id
                                ? item?.message
                                : `${item?.message?.substring(0, 100)}...`}
                            </p>
                            <div className="text-left">
                              {showMore && selectedId == item.id ? (
                                <span
                                  className=" small text-primary"
                                  style={{ fontSize: "10px" }}
                                  onClick={() => {
                                    hideText(item.id);
                                  }}
                                >
                                  پنهان کردن
                                </span>
                              ) : (
                                <span
                                  className=" small text-primary"
                                  style={{ fontSize: "10px" }}
                                  onClick={() => {
                                    showText(item.id);
                                  }}
                                >
                                  {" "}
                                  خواندن بیشتر
                                </span>
                              )}
                            </div>
                          </>
                        ) : (
                          <p className="mt-2 text-center">{item?.message}</p>
                        )}
                      </Col>
                    )}
                  </Col>
                ))}
            </Row>
          )}
          {showImage && (
            <Modal
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={showImage}
              onHide={handleClose}
            >
              <Modal.Body className="p-0">
                <Col xs={12} lg={12} xl={12} className="p-0">
                  {selectedImage.map(
                    (fileItem, key) =>
                      //این شرط حذف شود
                      key == 0 && (
                        <div key={key}>
                          <img
                            src={
                              process.env.REACT_APP_API_URL +
                              "/File/" +
                              fileItem +
                              `.jpg`
                            }
                            className="img-thumbnail w-100 py-0 px-0"
                            style={{ border: "0", height: "100%" }}
                            alt="no-image"
                          ></img>
                        </div>
                      )
                  )}
                </Col>
              </Modal.Body>
            </Modal>
          )}
        </div>
      </Container>
    </Container>
  );
}
export default KishPortInfo;
